import React from "react";
import {connect} from 'react-redux';
import {Radio, FormGroup} from "react-bootstrap";
import {getPaymentMethodDescription} from '../../common/paymentMethodsData';
import {PaymentTypes, PaymentMethod, JoinModes, URLs, PaymentPlans} from '../../common/constants';
import {translate} from '../../i18n/translate.js';
import {getJoinSelectedItems, getNextDeliveryDate, isEBTNonEligibleItems} from "../../common/basket";
import {getDiffFromNow} from "../../common/utils";

class PaymentMethods extends React.Component {
    handleChange = (event) => {
        if(event.target.value === 'on'){
            const dataKey =  event.target.attributes["data-key"];
            const key = dataKey.nodeValue;
            this.props.setSelectedMethod(key);
        }
    };

    getPaymentTitle = (paymentKey) => {
        let title = "";
        if(paymentKey === PaymentMethod.CHECK.key && this.props.staticData.farmCountry === 'CA'){
            title = "Cheque";
        }
        else if(paymentKey === PaymentMethod.CASH.key && this.props.staticData.cashPaymentMethodTitle && this.props.staticData.cashPaymentMethodTitle.length > 0){
            title = this.props.staticData.cashPaymentMethodTitle;
        }
        else if(paymentKey === PaymentMethod.PHONE.key && this.props.staticData.otherPaymentMethodTitle && this.props.staticData.otherPaymentMethodTitle.length > 0){
            title = this.props.staticData.otherPaymentMethodTitle;
        }
        else if(paymentKey === PaymentMethod.EBT_ONLINE.key && this.props.staticData.ebtOnlinePaymentMethodTitle && this.props.staticData.ebtOnlinePaymentMethodTitle.length > 0){
            title = this.props.staticData.ebtOnlinePaymentMethodTitle;
        }
        else{
            title = PaymentMethod[paymentKey].title;
        }

        const shortTitle = PaymentMethod[paymentKey].shortTitle ? PaymentMethod[paymentKey].shortTitle : title;
        const isAutomatic = (paymentKey === PaymentMethod.PAYPAL_PREAPPROVE.key) || (paymentKey === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) || (paymentKey === PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key);
        return {title, shortTitle, isAutomatic};
    };

    _getPayment = (paymentKey) => {
        let description = getPaymentMethodDescription(paymentKey, this.props.staticData, this.props.pageContext, this.props.isAddSubscription ? JoinModes.ADD : undefined);
        if (this.props.isAdmin)
            if (this.props.paymentType === PaymentTypes.CHARGE.type && this.props.hasToken && PaymentMethod[paymentKey].key !== PaymentMethod.PAYPAL_PREAPPROVE.key)
                description = translate("_usingPaymentDetailsOnFile");
            else
                description = undefined;
        let selected = paymentKey === this.props.selectedMethod;
        let disableMethod = false
        let title = this.getPaymentTitle(paymentKey);
        let className = paymentKey;
        if (paymentKey === PaymentMethod.PHONE.key && this.props.staticData.otherPaymentMethodTitle && this.props.staticData.otherPaymentMethodTitle === "Bitcoin") {
            className = "BITCOIN";
        }
        const checkMethodCustomDetails = this.props.staticData.checkMethodCustomDetails;
        if (checkMethodCustomDetails && paymentKey === PaymentMethod.CHECK.key) {
            const checkDetails = checkMethodCustomDetails.split('|');
            title = {title: checkDetails[0], shortTitle: checkDetails[0]};
            description = checkDetails[1];
        }
        const authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails = this.props.staticData.authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails;
        if (authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails && paymentKey === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) {
            const details = authorizeDotNetPreapproveMethodCustomDetailsMethodCustomDetails.split('|');
            title = {title: details[0], shortTitle: details[0]};
            description = details[1];
        }
        const ebtMethodCustomDetails = this.props.staticData.ebtMethodCustomDetails;
        if (paymentKey === PaymentMethod.EBT_ONLINE.key) {
            if (ebtMethodCustomDetails) {
                const ebtDetails = ebtMethodCustomDetails.split('|');
                if (ebtDetails.length === 1 || this.props.pageContext === URLs.JOIN) {
                    description += '<br/>' + ebtDetails[0];
                } else {
                    description += '<br/>' + ebtDetails[1];
                }
            }
            if (this.props.disableEBT) {
                disableMethod = true;
                if (this.props.pageContext===URLs.STORE) {
                    description = 'Your order includes SNAP non eligible items. If you wish to pay using EBT please remove those items.'
                }
            }
        }

        return (
            <div name="paymentMethod" className="payment-method" key={paymentKey}>
                <Radio name="methodType" onChange={this.handleChange} data-key={paymentKey} checked={selected} disabled={disableMethod}>
                    {this.props.isAdmin || this.props.clientViewPort.isXs ?
                        <span>
                            <b className={className} >{title.shortTitle}</b>
                            {!this.props.isAdmin && title.isAutomatic ?
                                <span>{translate("_AutomaticallyRecurringPayments")}</span>
                            : undefined}
                        </span>
                        :
                        <span>
                            <b className={className} >{title.title}</b>
                        </span>
                    }
                    {description ?
                        <div className="description" dangerouslySetInnerHTML={{__html: description}}>{}</div>
                        :
                        undefined
                    }
                </Radio>
            </div>
        )
    };

    getRemoveToken = () => {
        if (this.props.hasToken && (this.props.paymentType === PaymentTypes.PAYMENT_TOKEN.type ||
            (this.props.paymentType === PaymentTypes.UPDATE_PAYMENT.type && this.props.staticData.allowMemberToRemoveToken)))
            return (
                <div className="payment-method" >
                    <h4>{translate("_optionRemove")}</h4>
                    <Radio name="methodPlan" data-key={PaymentMethod.NONE.key} checked={this.props.selectedMethod === PaymentMethod.NONE.key} onChange={this.handleChange}>
                                    <span>
                                        <b className="remove-token">{translate("_optionRemoveAutomatic")}</b>
                                    </span>
                    </Radio>
                </div>
            );
        return null;
    };

    filterRelevantMethods = () => {
        return (this.props.paymentMethods || []).filter(paymentMethodKey => {
            return !(paymentMethodKey === PaymentMethod.EBT_ONLINE.key && this.props.hideEBT);
        })
    }

    render() {
        const methods = this.filterRelevantMethods();
        if(methods && (methods.length > 1 || (methods.length === 1 && methods[0] !== "BALANCE"))){
            return (
                <FormGroup>
                    <h4>{this.props.paymentType === PaymentTypes.CHARGE.type ? translate("Payment Method") :
                            (this.props.paymentType === PaymentTypes.UPDATE_PAYMENT.type || this.props.paymentType === PaymentTypes.PAYMENT_TOKEN.type) ? translate("Update payment details") :
                                (this.props.isAddSubscription && this.props.hasPreapproval ?
                                    translate("paymentMethodReuse") : translate("Select Payment Method"))}
                    </h4>
                    {methods.map(this._getPayment)}
                    {this.getRemoveToken()}
                </FormGroup>
            )
        } else if (this.props.paymentType === PaymentTypes.PAYMENT_TOKEN.type){
            //For case there are no defined payment methods but still there is a token
            return this.getRemoveToken();
        } else {
            return null;
        }
    }
}

//FIXME : move to containers
const mapStateToProps = (state, ownProps) => {
    const staticData = state.staticData || {};
    let hideEBT = false;
    let disableEBT = false;
    if (ownProps.pageContext===URLs.JOIN) {
        const summary = state.summary || {};
        const signupData = state.signupData || {};
        const orderStatus = state.orderStatus || {};
        const pickupSite = summary.pickupSite || {};
        const selectedItems = signupData.sharesData ? getJoinSelectedItems(signupData.sharesData.shares, signupData.sharesData.options).items : [];
        const orderTotal = (orderStatus.totals || {}).orderTotal || {};
        const selectedData = (signupData || {}).selectedData;
        const selectedPaymentPlan = (selectedData || {}).selectedPaymentPlan;
        const nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
        const schedules = signupData.schedules || {};
        const exceptionalPickupSites = (signupData.pickupSitesData || {}).exceptionalPickupSites;
        const summaryItems = summary.shareItems ? summary.shareItems.concat(summary.waitListItems) : [];
        let nextDeliveryDate;
        if (pickupSite && nextDeliveryDates) {
            nextDeliveryDate = getNextDeliveryDate(summary.pickupSite, selectedItems.concat(summaryItems), schedules, nextDeliveryDates);
            if (exceptionalPickupSites && exceptionalPickupSites.hasOwnProperty(summary.pickupSite.key)) {
                nextDeliveryDate = exceptionalPickupSites[summary.pickupSite.key];
            }
        }
        const hideEBTOnExtraCharges = staticData.hideEBTOnExtraCharges && ((pickupSite.extraCost > 0 || pickupSite.signupFee > 0) ||
            selectedItems.filter(item => item.salesTax).length > 0 ||
            orderTotal.tax > 0);
        const hideEBTByPaymentMethod = !selectedPaymentPlan || selectedPaymentPlan.type === PaymentPlans.F ||
            ((selectedPaymentPlan.type === PaymentPlans.DistributionDynamicPrePayment || selectedPaymentPlan.type === PaymentPlans.DynamicPrePayment) && selectedPaymentPlan.amount > 1);
        const hideEBTDueToNextDeliveryDate = getDiffFromNow(nextDeliveryDate) > 14 * 24 * 60 * 60 * 1000; //Next delivery date is more than 2 weeks ahead
        hideEBT = hideEBTOnExtraCharges || hideEBTByPaymentMethod || hideEBTDueToNextDeliveryDate;
    } else if (ownProps.pageContext===URLs.STORE) {
        const orderStatus = (state.orderStatus||{});
        disableEBT = isEBTNonEligibleItems(orderStatus.orderedItems.editableItems);
    }
    return {
        staticData: staticData,
        clientViewPort: (state.clientViewPort || {}),
        isAdmin: ownProps.paymentType === PaymentTypes.CHARGE.type || ownProps.paymentType === PaymentTypes.PAYMENT_TOKEN.type,
        hideEBT: hideEBT,
        disableEBT: disableEBT,
        pageContext: ownProps.pageContext
    };
};

export default connect(mapStateToProps, null)(PaymentMethods);



// WEBPACK FOOTER //
// ./src/components/pay/PaymentMethods.js